import React from "react";
import TldrBase from "../TldrLogin/TldrBase";
import { Link } from "react-router-dom";
import { ROOT } from "../_utils/routes";
import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Box, Icon } from "@chakra-ui/react";

const Tldr404 = () => {
  const { t } = useTranslation(["common"]);
  return (
    <TldrBase heading={t("sorry")} subheading={t("errors.page_not_found")}>
      <Box className="secondary-links" textAlign="center" mt={2}>
        <Link to={ROOT}>
          <Icon as={FaArrowLeft} mr={1} />
          {t("back_to_login")}
        </Link>
      </Box>
    </TldrBase>
  );
};
export default Tldr404;
